<app-secondary-popup
  [title]="'Outreach Link Details'"
  [primaryActionName]="'Delete'"
  [secondaryActionName]="disableEnableText"
  (primaryAction)="showDeleteLinkPopup = true"
  (secondaryAction)="showDisableLinkPopup = true"
  (popupClosed)="closePopup($event)"
>
  <div class="link-details-container">
    <!-- Loading State -->
    @if (loading) {
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading link details...</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !loading) {
      <div class="error-state">
        <div class="error-icon">⚠️</div>
        <p>{{ error }}</p>
      </div>
    }

    <!-- Content -->
    @if (outreachLinkDetails && !loading && !error) {
      <div class="view-mode">
        <!-- Basic Details Section -->
        <div class="detail-section" id="tour-link-details">
          <div class="basic-details-grid">
            <!-- Link Name Card -->
            <div
              class="detail-card feature-card"
              [class.editing-mode]="isEditingName"
            >
              <div class="card-header">
                <div class="card-icon name-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M20,16V4H4V16H8.5L12,19.5L15.5,16H20Z"
                    />
                  </svg>
                </div>
                <span class="card-label">Link Name</span>
              </div>
              <div class="card-content">
                @if (!isEditingName) {
                  <div class="name-display">
                    <span class="name-text">{{
                      outreachLinkDetails.name
                    }}</span>
                    <button
                      type="button"
                      class="btn btn-icon btn-edit"
                      (click)="startEditName()"
                      title="Edit link name"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"
                        />
                      </svg>
                    </button>
                  </div>
                } @else {
                  <div class="name-edit">
                    <input
                      type="text"
                      class="form-input name-input"
                      [(ngModel)]="editedName"
                      placeholder="Enter link name"
                      maxlength="255"
                      [disabled]="isSaving"
                    />
                    <div class="edit-actions">
                      <button
                        type="button"
                        class="btn btn-icon btn-save"
                        (click)="saveEditName()"
                        [disabled]="!editedName.trim() || isSaving"
                        title="Save changes"
                      >
                        @if (!isSaving) {
                          <span>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path
                                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                              />
                            </svg>
                          </span>
                        }
                        @if (isSaving) {
                          <span class="saving-spinner"></span>
                        }
                      </button>
                      <button
                        type="button"
                        class="btn btn-icon btn-cancel"
                        (click)="cancelEditName()"
                        [disabled]="isSaving"
                        title="Cancel editing"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
            <!-- Visibity of submissions Card -->
            <div
              id="tour-link-visibility"
              class="detail-card feature-card"
              [class.editing-mode]="submissionVisibilityEditMode"
            >
              <div class="card-header">
                <div class="card-icon name-icon">
                  @if (outreachLinkDetails.submission_visibility === 1) {
                    <app-svg-icon
                      [iconName]="'globe.svg'"
                      [height]="'18px'"
                      [width]="'18px'"
                      [style.fill]="'currentColor'"
                    ></app-svg-icon>
                  } @else {
                    <app-svg-icon
                      [iconName]="'private-lock.svg'"
                      [height]="'18px'"
                      [width]="'18px'"
                      [style.fill]="'currentColor'"
                    ></app-svg-icon>
                  }
                </div>
                <span class="card-label">Visibility of Submissions</span>
              </div>
              <div class="card-content">
                @if (!submissionVisibilityEditMode) {
                  <div class="name-display">
                    <span class="name-text">{{
                      outreachLinkDetails.submission_visibility === 1
                        ? "Public"
                        : "Private"
                    }}</span>
                    <button
                      type="button"
                      class="btn btn-icon btn-edit"
                      (click)="editSubmissionVisibility()"
                      title="Edit Visibility of submissions"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"
                        />
                      </svg>
                    </button>
                  </div>
                } @else {
                  <div class="name-edit">
                    <div class="radio-group">
                      <label>
                        <input
                          type="radio"
                          name="submissionVisibility"
                          [value]="1"
                          [(ngModel)]="submissionVisibility"
                          required
                        />
                        Public
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="submissionVisibility"
                          [value]="2"
                          [(ngModel)]="submissionVisibility"
                          required
                        />
                        Private
                      </label>
                    </div>
                    <div class="edit-actions">
                      <button
                        type="button"
                        class="btn btn-icon btn-save"
                        (click)="saveEditSubmissionVisibility()"
                        [disabled]="!submissionVisibility || isSaving"
                        title="Save changes"
                      >
                        @if (!isSaving) {
                          <span>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path
                                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                              />
                            </svg>
                          </span>
                        }
                        @if (isSaving) {
                          <span class="saving-spinner"></span>
                        }
                      </button>
                      <button
                        type="button"
                        class="btn btn-icon btn-cancel"
                        (click)="cancelEditSubmissionVisibility()"
                        [disabled]="isSaving"
                        title="Cancel editing"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>

            <!-- Status Card -->
            <div class="detail-card status-card">
              <div class="card-header">
                <div class="card-icon status-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"
                    />
                  </svg>
                </div>
                <span class="card-label">Status</span>
              </div>
              <div class="card-content">
                <span
                  class="status-badge modern-badge"
                  [class.active]="outreachLinkDetails.is_active"
                  [class.inactive]="!outreachLinkDetails.is_active"
                >
                  <span class="status-indicator"></span>
                  {{ outreachLinkDetails.is_active ? "Active" : "Inactive" }}
                </span>
              </div>
            </div>

            <!-- Created By Card -->
            <div class="detail-card creator-card">
              <div class="card-header">
                <div class="card-icon creator-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                    />
                  </svg>
                </div>
                <span class="card-label">Created By</span>
              </div>
              <div class="card-content">
                <div class="creator-info">
                  <span class="creator-name">{{
                    outreachLinkDetails.created_by_user.first_name +
                      " " +
                      outreachLinkDetails.created_by_user.last_name
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Created Date Card -->
            <div class="detail-card date-card">
              <div class="card-header">
                <div class="card-icon date-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19M5,6V5H19V6H5Z"
                    />
                  </svg>
                </div>
                <span class="card-label">Created Date</span>
              </div>
              <div class="card-content">
                <div class="date-info">
                  <span class="date-primary">{{
                    outreachLinkDetails.created_on_utc | date: "MMM dd, yyyy"
                  }}</span>
                  <span class="date-secondary">{{
                    outreachLinkDetails.created_on_utc | date: "HH:mm"
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional Parameters Section -->
          @if (
            outreachLinkDetails.meta_data &&
            getObjectKeys(outreachLinkDetails.meta_data).length > 0
          ) {
            <div class="metadata-section">
              <div class="metadata-header">
                <div class="metadata-title">
                  <svg
                    class="metadata-icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
                    />
                  </svg>
                  <span>Additional Parameters</span>
                </div>
              </div>
              <div class="metadata-grid">
                @for (
                  item of outreachLinkDetails.meta_data | keyvalue;
                  track $index
                ) {
                  <div class="metadata-item">
                    <div class="metadata-key">{{ item.key }}</div>
                    <div class="metadata-value">{{ item.value }}</div>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <!-- Access Types & Links Section -->
        <div class="detail-section">
          <div class="section-header">
            <h3 class="section-title">Generated Links & Access</h3>
            <button
              id="tour-view-submissions"
              type="button"
              class="btn btn-view-submissions"
              (click)="viewSubmissions()"
              title="View submissions from this link"
            >
              <span>View Submissions</span>
            </button>
          </div>

          <!-- Regular Link -->
          <div class="link-group">
            <div class="link-header">
              <span class="detail-label">Standard Link</span>
              <div class="access-stats" id="tour-link-view-submissions">
                <span class="views-count"
                  >{{ getViewsCount("link") }} views |
                  {{
                    outreachLinkDetails.submissions -
                      outreachLinkDetails.qr_submissions
                  }}
                  submissions</span
                >
              </div>
            </div>
            <div class="link-output" id="tour-standard-links">
              <input
                type="text"
                class="form-input link-display"
                [value]="getLinkUrl('link')"
                readonly
              />
              <button
                type="button"
                class="btn btn-icon btn-copy"
                [class.btn-copy-success]="linkCopySuccess"
                (click)="copyToClipboard(getLinkUrl('link'), 'link')"
                [title]="linkCopySuccess ? 'Copied!' : 'Copy to clipboard'"
              >
                @if (!linkCopySuccess) {
                  <app-svg-icon
                    [iconName]="'copy.svg'"
                    [height]="'18px'"
                    [width]="'18px'"
                  ></app-svg-icon>
                } @else {
                  <span class="copy-success-text">✓</span>
                }
              </button>
            </div>
          </div>

          <!-- QR Code Link -->
          <div class="link-group">
            <div class="link-header">
              <span class="detail-label">QR Code</span>
              <div class="access-stats">
                <span class="views-count"
                  >{{ getViewsCount("qr") }} views |
                  {{ outreachLinkDetails.qr_submissions }} submissions</span
                >
              </div>
            </div>

            <!-- QR Code Display -->
            <div class="qr-code-section">
              <div
                class="qr-code-container"
                #qrCodeCanvas
                id="tour-qr-code-container"
              >
                <qrcode
                  [qrdata]="getLinkUrl('qr')"
                  [width]="200"
                  [errorCorrectionLevel]="'M'"
                  [colorDark]="'#000000'"
                  [colorLight]="'#ffffff'"
                ></qrcode>
                <img
                  src="assets/deeproots-logo-v2.jpg"
                  alt="ACC Logo"
                  class="qr-logo-overlay"
                />
              </div>
              <div class="qr-code-actions">
                <button
                  type="button"
                  class="btn btn-qr-action btn-print"
                  (click)="printQRCode()"
                  title="Print QR Code"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                    />
                  </svg>
                  <span>Print</span>
                </button>
              </div>
              <p class="qr-code-description">
                Scan this QR code to access the outreach link directly
              </p>
            </div>
          </div>
        </div>

        <!-- Access Summary -->
        <div class="detail-section">
          <h3 class="section-title">Access Summary</h3>
          <div class="access-summary">
            @if (
              outreachLinkDetails.access_types &&
              outreachLinkDetails.access_types.length > 0
            ) {
              @for (
                accessType of outreachLinkDetails.access_types;
                track $index
              ) {
                <div class="access-summary-item">
                  <div class="access-type">
                    <span class="access-type-label">
                      {{
                        accessType.access_type === "link"
                          ? "Standard Link"
                          : "QR Code"
                      }}
                    </span>
                    <span class="access-type-icon">
                      {{ accessType.access_type === "link" ? "🔗" : "📱" }}
                    </span>
                  </div>
                  <div class="access-views">
                    <span class="views-number">{{ accessType.views }}</span>
                    <span class="views-text">{{
                      accessType.views === 1 ? "view" : "views"
                    }}</span>
                  </div>
                </div>
              }
            } @else {
              <!-- Default access summary when no access types exist -->
              <div class="access-summary-item">
                <div class="access-type">
                  <span class="access-type-label">Standard Link</span>
                  <span class="access-type-icon">🔗</span>
                </div>
                <div class="access-views">
                  <span class="views-number">{{ getViewsCount("link") }}</span>
                  <span class="views-text">{{
                    getViewsCount("link") === 1 ? "view" : "views"
                  }}</span>
                </div>
              </div>
              <div class="access-summary-item">
                <div class="access-type">
                  <span class="access-type-label">QR Code</span>
                  <span class="access-type-icon">📱</span>
                </div>
                <div class="access-views">
                  <span class="views-number">{{ getViewsCount("qr") }}</span>
                  <span class="views-text">{{
                    getViewsCount("qr") === 1 ? "view" : "views"
                  }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (showDeleteLinkPopup) {
      <app-popup
        [heading]="'Are you sure you want to delete this link?'"
        [confirmText]="'Delete'"
        [cancelText]="'Cancel'"
        [popupPosition]="'absolute'"
        (confirmClicked)="deleteLink()"
        (cancelClicked)="showDeleteLinkPopup = false"
      >
        <div class="lead-unassign-popup-content">
          {{ outreachLinkDetails?.name }}
        </div>
      </app-popup>
    }
    @if (showDisableLinkPopup) {
      <app-popup
        [heading]="
          outreachLinkDetails?.is_active
            ? 'Are you sure you want to disable this link?'
            : 'Are you sure you want to enable this link?'
        "
        [confirmText]="outreachLinkDetails?.is_active ? 'Disable' : 'Enable'"
        [cancelText]="'Cancel'"
        [popupPosition]="'absolute'"
        (confirmClicked)="disableEnableLink()"
        (cancelClicked)="showDisableLinkPopup = false"
      >
        <div class="lead-unassign-popup-content">
          {{ outreachLinkDetails?.name }}
        </div>
      </app-popup>
    }

    @if (showLanguageSelectionPopup) {
      <app-popup
        [heading]="'Select Language for QR Code Print'"
        [showCloseIcon]="true"
        [showFooterButtons]="false"
        [popupPosition]="'absolute'"
      >
        <div
          class="language-selection-popup-content"
          (appClickOutside)="showLanguageSelectionPopup = false"
        >
          <p class="language-selection-description">
            Choose the language for the printed QR code content:
          </p>
          <div class="language-options">
            @for (language of languages; track language.code) {
              <button
                type="button"
                class="btn btn-language-option"
                (click)="printQRCodeWithLanguage(language.code)"
              >
                <span class="language-flag">
                  {{ language.code === "en" ? "🇺🇸" : "🇪🇸" }}
                </span>
                <span class="language-name">{{ language.name }}</span>
              </button>
            }
          </div>
        </div>
      </app-popup>
    }
  </div>
</app-secondary-popup>
